import { render, staticRenderFns } from "./Assuntos.vue?vue&type=template&id=416651b6&scoped=true"
import script from "./Assuntos.vue?vue&type=script&lang=ts"
export * from "./Assuntos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416651b6",
  null
  
)

export default component.exports